import { registerPlugin } from '@capacitor/core';

/** O plugin nativo do Android (`ApkUpdaterPlugin.java`): baixa o APK novo e abre o instalador. Só existe dentro do app. */
interface ApkUpdaterPlugin {
  canInstall(): Promise<{ allowed: boolean }>;
  openInstallSettings(): Promise<void>;
  downloadAndInstall(options: { url: string; sha256: string }): Promise<void>;
  addListener(
    event: 'progress',
    listener: (data: { received: number; total: number }) => void,
  ): Promise<{ remove: () => Promise<void> }>;
}

export const ApkUpdater = registerPlugin<ApkUpdaterPlugin>('ApkUpdater');

/** O que a tela precisa do instalador; separado do plugin para os testes trocarem por um falso. */
export interface Updater {
  canInstall: () => Promise<boolean>;
  openInstallSettings: () => Promise<void>;
  /** Baixa e abre o instalador. `onProgress` recebe de 0 a 1 (ou `null` se o tamanho não é conhecido). */
  downloadAndInstall: (
    request: { url: string; sha256: string },
    onProgress: (fraction: number | null) => void,
  ) => Promise<void>;
}

export const nativeUpdater: Updater = {
  canInstall: async () => (await ApkUpdater.canInstall()).allowed,
  openInstallSettings: () => ApkUpdater.openInstallSettings(),
  downloadAndInstall: async (request, onProgress) => {
    const listener = await ApkUpdater.addListener('progress', ({ received, total }) =>
      onProgress(total > 0 ? Math.min(1, received / total) : null),
    );
    try {
      await ApkUpdater.downloadAndInstall(request);
    } finally {
      await listener.remove();
    }
  },
};
